import React, { Component } from 'react';
import './MasonryLayout.scss';
import Masonry from 'react-masonry-component';
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from '../../i18n';
import Loading from '@/Common/loading/loading'
import FormatHelper from '../../utils/FormatHelper'

const masonryOptions = {
    transitionDuration: 0
};

const imagesLoadedOptions = { background: '.my-bg-image-el' }
class MasonryLayout extends Component {
    constructor(props, context) {
        super(props, context);
        if (!this.props.disableAnimation) {
            AOS.init({
                duration: 400,
                once: true,
            });
        }
    }
    componentWillReceiveProps() {
        if (!this.props.disableAnimation) {
            AOS.refresh();
        }
    }
    render() {
        const { gallerys, onThumbnailClicked, lang, shareClick, onHeartClick } = this.props

        if(!gallerys){
            return <Loading />
        }
        return (
            <Masonry
                className={'my-gallery-class'} // default ''
                elementType={'div'} // default 'div'
                options={masonryOptions} // default {}
                disableImagesLoaded={false} // default false
                updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                imagesLoadedOptions={imagesLoadedOptions} // default {}
            >
                {
                    gallerys.map((item, index) => {
                        const views = FormatHelper.convertToKMB(item.viewCount)
                        const comments = FormatHelper.convertToKMB(item.comments)
                        const likes = FormatHelper.convertToKMB(item.likeMembers)
                        const hashTags = item.hashtag ? item.hashtag.split(' ') : []

                        return (
                            <div lang={lang} data-aos={this.props.disableAnimation ? "" : "fade-up"} key={index} className="image-element-class" >
                                {
                                    item.thumbnailURL ?
                                        <div className='image-element-wrapper'>
                                            {   // staff pick 아이콘 부재로 인해 임시 아이콘 배치, 추후 src 및 크기조정 필요
                                                item.isStaffPick ?
                                                    <img className='staffPickIcon' src="https://front.videomonster.com/images-u6yd72dy/web/staffpick_icon.png" alt={'staffPickIcon'} />
                                                    :
                                                    ''
                                            }
                                            {/* {   // hot100 icon 노출 로직, 추후 hot 100 api 연동 시 수정 필요
                                                item.isStaffPick ?
                                                    <img className='hot100Icon' src={testImg01} alt={'hot100Icon'} />
                                                    :
                                                    ''
                                            } */}
                                            <img className='galleryImg' src={item.thumbnailURL} alt={"galleryImg"} />
                                        </div>  
                                        : 
                                        <div style={{ width: "100%", height: "300px", background: "black" }}></div>
                                }

                                <div className="black_window" onClick={onThumbnailClicked(item._id)}>                                    
                                    <div className="hashTag-container">
                                        {hashTags.map(tag => { return <span className="hashTag-name">{tag}</span> })}
                                    </div>
                                    <div className="likesAndComment">
                                        <div className="thumbnail-item">
                                            <img src="https://front.videomonster.com/images-u6yd72dy/web/viewsIcon.svg" alt="speechicon"></img>
                                            {views}
                                        </div>
                                        <div className="thumbnail-item" onClick={(e) => onHeartClick(item._id,e)}>
                                            <div className="gallery_video-heart">
                                                <span className={item.isLike ? "click-heart heart" : "heart"}></span>
                                            </div>
                                            {likes}
                                        </div>
                                        <div className="thumbnail-item">
                                            <img className="comment" src="https://front.videomonster.com/images-u6yd72dy/mobile/comment.png" alt="speechicon"></img>
                                            {comments}
                                        </div>
                                    </div>
                                    
                                    <div className="share-btn-container">
                                        <img src="https://front.videomonster.com/images-u6yd72dy/web/shareIcon_white_new.svg" alt="shareIcon" onClick={shareClick(item)}/>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {/* {childElements} */}
            </Masonry>
        );
    }
}

export default MasonryLayout;